module.exports = __webpack_public_path__ + "static/waltz_roll_mini_1-f71f3c963757e639d146180294898a44.jpg";